import {
  BookOpenIcon,
  ChartBarSquareIcon,
  UserCircleIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/solid'

export const MENUS = {
  MNU000001: {
    id: 'MNU000001',
    type: 'accordion',
    label: '회원 관리',
    icon: <UserCircleIcon className="h-5 w-5 text-label-alternative" />,
    href: null,
  },
  MNU000002: {
    id: 'MNU000002',
    type: 'link',
    label: '회원 관리',
    icon: null,
    href: '/users',
  },
  MNU000003: {
    id: 'MNU000003',
    type: 'link',
    label: '관리자 관리',
    icon: null,
    href: '/admin',
  },
  MNU000004: {
    id: 'MNU000004',
    type: 'accordion',
    label: '교육 관리',
    icon: <BookOpenIcon className="h-5 w-5 text-label-alternative" />,
    href: null,
  },
  MNU000005: {
    id: 'MNU000005',
    type: 'link',
    label: '통계 관리',
    icon: <ChartBarSquareIcon className="h-5 w-5 text-label-alternative" />,
    href: '/statistics',
  },
  MNU000006: {
    id: 'MNU000006',
    type: 'accordion',
    label: '운영 관리',
    icon: <WrenchScrewdriverIcon className="h-5 w-5 text-label-alternative" />,
    href: null,
    divider: true,
  },
  MNU000007: {
    id: 'MNU000007',
    type: 'link',
    label: '온라인 교육 과정',
    icon: null,
    href: '/programs',
  },
  MNU000008: {
    id: 'MNU000008',
    type: 'link',
    label: '교육기관 설정',
    icon: null,
    href: '/settings/company',
  },
  MNU000009: {
    id: 'MNU000009',
    type: 'link',
    label: '이용약관 설정',
    icon: null,
    href: '/settings/policy',
  },
  MNU000010: {
    id: 'MNU000010',
    type: 'link',
    label: '교육과정 관리',
    icon: null,
    href: '/programs/{programCode}',
  },
  MNU000011: {
    id: 'MNU000011',
    type: 'link',
    label: '수강생',
    icon: null,
    href: '/programs/{programCode}/student',
  },
  MNU000012: {
    id: 'MNU000012',
    type: 'link',
    label: '커리큘럼',
    icon: null,
    href: '/programs/{programCode}/curriculum',
  },
  MNU000013: {
    id: 'MNU000013',
    type: 'link',
    label: '학습퀴즈',
    icon: null,
    href: '/programs/{programCode}/quiz',
  },
  MNU000014: {
    id: 'MNU000014',
    type: 'link',
    label: '공지사항',
    icon: null,
    href: '/programs/{programCode}/notice',
  },
  MNU000015: {
    id: 'MNU000015',
    type: 'link',
    label: 'Q&A',
    icon: null,
    href: '/programs/{programCode}/qna',
  },
  MNU000016: {
    id: 'MNU000016',
    type: 'link',
    label: '설문조사',
    icon: null,
    href: '/programs/{programCode}/survey',
  },
  MNU000018: {
    id: 'MNU000018',
    type: 'link',
    label: '프로젝트',
    icon: null,
    href: '/programs/{programCode}/project',
  },
  MNU000019: {
    id: 'MNU000019',
    type: 'link',
    label: '모집 관리',
    icon: null,
    href: '/programs/{programCode}/application',
  },
}
